import { renderOtherSchoolResultEntryPage } from '../result_entry.ts';

export async function renderOtherSchoolResultEditPage(app: HTMLElement): Promise<void> {
  // Leverage the query-aware Entry module for zero code duplication
  await renderOtherSchoolResultEntryPage(app);
}
